import { render } from "./HelpAttachMaterials.vue?vue&type=template&id=960eb664"
import script from "./HelpAttachMaterials.vue?vue&type=script&lang=js"
export * from "./HelpAttachMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__